/* eslint-disable @typescript-eslint/no-unused-vars */
import {StyleSheet, Text, View} from 'react-native';
import React from 'react';

interface ItemSeparatorProps {
  row?: boolean;
  size?: number;
}

const Spacer: React.FC<ItemSeparatorProps> = ({row = false, size = 5}) => {
  const style = row
    ? {height: '100%', width: size}
    : {width: '100%', height: size};
  // @ts-ignore
  return <View style={style} />;
};

export default Spacer;

const styles = StyleSheet.create({});
